<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect fill="none" />
    <g clip-path="url(#clip0_387_1105)">
        <rect width="390" height="656" transform="translate(-175 -270)" fill="none" />
        <rect x="-155" y="-258" width="350" height="624" rx="8" fill="none" />
        <rect x="-154.5" y="-19.5" width="349" height="131" rx="7.5" fill="none" />
        <rect x="-154.5" y="-19.5" width="349" height="131" rx="7.5" stroke="currentColor" stroke-dasharray="4 4" />
        <path
            d="M35 25V31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V25"
            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M28.3334 13.3333L20 5L11.6667 13.3333" stroke="currentColor" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M20 5V25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
        <clipPath id="clip0_387_1105">
            <rect width="390" height="656" transform="translate(-175 -270)" />
        </clipPath>
    </defs>
</svg>
